module.exports = __webpack_public_path__ + "static/img/card-title3.623084b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/weTech/card-title3.png
// module id = +ZH+
// module chunks = 2